// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class AllBanksFireServiceResponse implements flatbuffers.IUnpackableObject<AllBanksFireServiceResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AllBanksFireServiceResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAllBanksFireServiceResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksFireServiceResponse,
  ): AllBanksFireServiceResponse {
    return (obj || new AllBanksFireServiceResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsAllBanksFireServiceResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksFireServiceResponse,
  ): AllBanksFireServiceResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AllBanksFireServiceResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankName(): string | null;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  bankName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  liftName(): string | null;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  liftName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  date(): string;
  date(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  date(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  mode(): string;
  mode(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  mode(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  start(): string;
  start(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  start(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  end(): string;
  end(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  end(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  duration(): string;
  duration(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  duration(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  seconds(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  bankId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startAllBanksFireServiceResponse(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankNameOffset, 0);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftNameOffset, 0);
  }

  static addDate(builder: flatbuffers.Builder, dateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, dateOffset, 0);
  }

  static addMode(builder: flatbuffers.Builder, modeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, modeOffset, 0);
  }

  static addStart(builder: flatbuffers.Builder, startOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, startOffset, 0);
  }

  static addEnd(builder: flatbuffers.Builder, endOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, endOffset, 0);
  }

  static addDuration(builder: flatbuffers.Builder, durationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, durationOffset, 0);
  }

  static addSeconds(builder: flatbuffers.Builder, seconds: number) {
    builder.addFieldInt32(7, seconds, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankId: number) {
    builder.addFieldInt16(8, bankId, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(9, liftId, 0);
  }

  static endAllBanksFireServiceResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 8); // date
    builder.requiredField(offset, 10); // mode
    builder.requiredField(offset, 12); // start
    builder.requiredField(offset, 14); // end
    builder.requiredField(offset, 16); // duration
    return offset;
  }

  static createAllBanksFireServiceResponse(
    builder: flatbuffers.Builder,
    bankNameOffset: flatbuffers.Offset,
    liftNameOffset: flatbuffers.Offset,
    dateOffset: flatbuffers.Offset,
    modeOffset: flatbuffers.Offset,
    startOffset: flatbuffers.Offset,
    endOffset: flatbuffers.Offset,
    durationOffset: flatbuffers.Offset,
    seconds: number,
    bankId: number,
    liftId: number,
  ): flatbuffers.Offset {
    AllBanksFireServiceResponse.startAllBanksFireServiceResponse(builder);
    AllBanksFireServiceResponse.addBankName(builder, bankNameOffset);
    AllBanksFireServiceResponse.addLiftName(builder, liftNameOffset);
    AllBanksFireServiceResponse.addDate(builder, dateOffset);
    AllBanksFireServiceResponse.addMode(builder, modeOffset);
    AllBanksFireServiceResponse.addStart(builder, startOffset);
    AllBanksFireServiceResponse.addEnd(builder, endOffset);
    AllBanksFireServiceResponse.addDuration(builder, durationOffset);
    AllBanksFireServiceResponse.addSeconds(builder, seconds);
    AllBanksFireServiceResponse.addBankId(builder, bankId);
    AllBanksFireServiceResponse.addLiftId(builder, liftId);
    return AllBanksFireServiceResponse.endAllBanksFireServiceResponse(builder);
  }

  unpack(): AllBanksFireServiceResponseT {
    return new AllBanksFireServiceResponseT(
      this.bankName(),
      this.liftName(),
      this.date(),
      this.mode(),
      this.start(),
      this.end(),
      this.duration(),
      this.seconds(),
      this.bankId(),
      this.liftId(),
    );
  }

  unpackTo(_o: AllBanksFireServiceResponseT): void {
    _o.bankName = this.bankName();
    _o.liftName = this.liftName();
    _o.date = this.date();
    _o.mode = this.mode();
    _o.start = this.start();
    _o.end = this.end();
    _o.duration = this.duration();
    _o.seconds = this.seconds();
    _o.bankId = this.bankId();
    _o.liftId = this.liftId();
  }

  unpackFields(...fields: string[]): AllBanksFireServiceResponseT {
    const t = new AllBanksFireServiceResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("date")) {
      t.date = this.date();
    }
    if (fieldSet.has("mode")) {
      t.mode = this.mode();
    }
    if (fieldSet.has("start")) {
      t.start = this.start();
    }
    if (fieldSet.has("end")) {
      t.end = this.end();
    }
    if (fieldSet.has("duration")) {
      t.duration = this.duration();
    }
    if (fieldSet.has("seconds")) {
      t.seconds = this.seconds();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    return t;
  }
}

export class AllBanksFireServiceResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankName: string | Uint8Array | null = null,
    public liftName: string | Uint8Array | null = null,
    public date: string | Uint8Array | null = null,
    public mode: string | Uint8Array | null = null,
    public start: string | Uint8Array | null = null,
    public end: string | Uint8Array | null = null,
    public duration: string | Uint8Array | null = null,
    public seconds: number = 0,
    public bankId: number = 0,
    public liftId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.date === null || this.date === undefined) {
      throw new Error('Required field "date" is not set');
    }
    if (this.mode === null || this.mode === undefined) {
      throw new Error('Required field "mode" is not set');
    }
    if (this.start === null || this.start === undefined) {
      throw new Error('Required field "start" is not set');
    }
    if (this.end === null || this.end === undefined) {
      throw new Error('Required field "end" is not set');
    }
    if (this.duration === null || this.duration === undefined) {
      throw new Error('Required field "duration" is not set');
    }
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const date = this.date !== null ? builder.createString(this.date!) : 0;
    const mode = this.mode !== null ? builder.createString(this.mode!) : 0;
    const start = this.start !== null ? builder.createString(this.start!) : 0;
    const end = this.end !== null ? builder.createString(this.end!) : 0;
    const duration = this.duration !== null ? builder.createString(this.duration!) : 0;

    return AllBanksFireServiceResponse.createAllBanksFireServiceResponse(
      builder,
      bankName,
      liftName,
      date,
      mode,
      start,
      end,
      duration,
      this.seconds,
      this.bankId,
      this.liftId,
    );
  }

  clone(): AllBanksFireServiceResponseT {
    const obj = new AllBanksFireServiceResponseT();
    obj.bankName = this.bankName;
    obj.liftName = this.liftName;
    obj.date = this.date;
    obj.mode = this.mode;
    obj.start = this.start;
    obj.end = this.end;
    obj.duration = this.duration;
    obj.seconds = this.seconds;
    obj.bankId = this.bankId;
    obj.liftId = this.liftId;
    return obj;
  }

  equals(other: AllBanksFireServiceResponseT): boolean {
    if (this.bankName !== other.bankName) return false;
    if (this.liftName !== other.liftName) return false;
    if (this.date !== other.date) return false;
    if (this.mode !== other.mode) return false;
    if (this.start !== other.start) return false;
    if (this.end !== other.end) return false;
    if (this.duration !== other.duration) return false;
    if (this.seconds !== other.seconds) return false;
    if (this.bankId !== other.bankId) return false;
    if (this.liftId !== other.liftId) return false;
    return true;
  }
}

export function verifyAllBanksFireServiceResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "date");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "mode");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "start");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "end");
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 16, "duration");
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 2);
    verifier.checkScalarField(tablePos, 22, 2);
  } finally {
    verifier.popDepth();
  }
}
